import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { PlanError } from '../../types';
import { MdCheckCircle, MdError } from 'react-icons/md';
import { palette } from '../../constants/styles';

const propTypes = {};

const defaultProps = {};

const StyledStatusComponent = styled.div`
display: flex;
align-items: center;
justify-content: center;
  
`; 

type Props = {
  error: PlanError;
  building: boolean;
  success: boolean;
  planId: string;
  handleClick: (id: string) => void;
}

const spinAnim = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Loader = styled.div`
  border: 3px solid #f3f3f3; /* Light grey */
  border-top: 3px solid #333333; /* Blue */
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: ${spinAnim} 2s linear infinite;

`;

const PlanLoading = () => (
  <Loader>

  </Loader>
)

export default function PlanStatusComponent({error, building, success, handleClick = () => {}, planId}: Props) {
  let Component;
  if (error) {
    Component =  <MdError
              style={{ cursor: 'pointer' }}
              onClick={() => handleClick(planId)}
              color="#FF0033"
              size={30}
            />;
  } 
  if (building) {
    Component =  <PlanLoading />;
  }
   if (success) {
    Component =  <MdCheckCircle
            style={{ cursor: 'pointer' }}
            color="#00C853"
            onClick={() => handleClick(planId)}
            size={30}

          />;
  }
  return (
    <StyledStatusComponent>
      {Component}
    </StyledStatusComponent>
  );
}

PlanStatusComponent.propTypes = propTypes;
PlanStatusComponent.defaultProps = defaultProps;